import { render, staticRenderFns } from "./automationDetail.vue?vue&type=template&id=1e0665c2&scoped=true"
import script from "./automationDetail.vue?vue&type=script&lang=js"
export * from "./automationDetail.vue?vue&type=script&lang=js"
import style0 from "./automationDetail.vue?vue&type=style&index=0&id=1e0665c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0665c2",
  null
  
)

export default component.exports